module.exports = __webpack_public_path__ + "static/media/aauxnext-mdit.d33a6640.woff2";